<div class="text-center">
    <p>404</p>
    <div>{{'error.404' | translate}}</div>
</div>